<script lang="ts">
    import { Card, CardHeader, Col, Row } from "sveltestrap";
    import {leftSideFilter} from "../../../../store"
    import { Filters } from "../../../../utils/Constant/Constant";
    import FilterSection from "./FilterSection.svelte";
    import ProductSearch from "./ProductSearch.svelte";
    //  for filter sidebar open
    const sidebarOn = () => {
        leftSideFilter.update(value => value = !value)
    }
    
</script>
<Row>
    <Col md="12">
        <div class="pro-filter-sec">
            <div class="product-sidebar">
                <div class="filter-section">
                    <Card>
                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                        <CardHeader on:click={sidebarOn}>
                            <h6 class="mb-0 f-w-600">{Filters}
                                <span class="pull-right">
                                    <i class="fa fa-chevron-down toggle-data"></i>
                                </span>
                            </h6>
                        </CardHeader>
                        <FilterSection />
                    </Card>
                </div>
            </div>
            <ProductSearch />
        </div>
    </Col>
</Row>